interface FloatingInputProps {
  value: string;
  setValue: (value: string) => void;
  label: string;
  maxLength?: number;
  type?: string;
  width?: string;
  placeholder?: string;
  disableFloatingLabel?: boolean;
  disabled?: boolean;
}

const FloatingInput: React.FC<FloatingInputProps> = ({ value, setValue, label, maxLength = 30, type = 'text', width = 'w-full', placeholder, disableFloatingLabel = false, disabled = false }) => {
  // Show placeholder only when floating label is disabled OR when there's a value (label has floated up)
  const shouldShowPlaceholder = disableFloatingLabel || value.length > 0;
  const placeholderText = shouldShowPlaceholder ? (placeholder || '') : '';

  return (
    <div className={`relative ${width}`}>
<input
  type={type}
  id={label}
  value={value}
  onChange={(e) => setValue(e.target.value)}
  maxLength={maxLength}
  placeholder={placeholderText}
  aria-label={label}
  disabled={disabled}
  className={`peer h-14 w-full rounded-lg border font-Poppins ${
    value.length === maxLength ? 'border-red-500' : 'border-gray-300'
  } bg-white px-4 text-base text-gray-900 shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:ring-2 ${
    value.length === maxLength ? 'focus:border-red-500 focus:ring-red-500' : 'focus:border-primary focus:ring-primary'
  }`}
/>
{!disableFloatingLabel && (
<label
  htmlFor={label}
  className={`absolute left-4 text-base font-Poppins transition-all duration-200 ease-in-out transform origin-left pointer-events-none select-none ${
    value.length > 0
      ? '-translate-y-6 text-primary font-medium top-0'
      : 'top-4 text-gray-400 peer-focus:-translate-y-6 peer-focus:text-primary peer-focus:font-medium peer-focus:top-0'
  }`}
>
  {label}
</label>)}
</div>
  );
};

export default FloatingInput;